import { FC } from "react"
import Form from "../../../../form"
import { CreateSubscriptionPayload } from "../../../../../../types"

interface Props {
  values: CreateSubscriptionPayload
  setFormField: (name: string, value: any) => void
}

const PropertyLocationDetails: FC<Props> = ({ values, setFormField }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
      <Form.Input name="city" label="City" placeholder="Ex. Charlotte" />
      <Form.Input name="state" label="State" placeholder="Ex. NC" />
      <Form.Input
        name="zipcode"
        label="Zip code"
        placeholder="Ex. 28205"
        required
      />
    </div>
  )
}

export default PropertyLocationDetails
